// extracted by mini-css-extract-plugin
export default {"title":"SelectionCourseBlocks_title__8yGmR","body":"SelectionCourseBlocks_body__+1NNy","block":"SelectionCourseBlocks_block__NLYLY","text":"SelectionCourseBlocks_text__gzg2e"};